import { SceneWrapper, Select } from '~/components';
import { type FormikProps, useFormikContext } from '~/modules';
import type { CreditSimulationBankAccountFormValues } from './schema';
import { ButtonComponent, Input } from './styles';

interface CreditSimulationBankAccountProps {
  banks: Array<{
    value: string;
    label: string;
  }>;
}

const CreditSimulationBankAccount = ({
  banks,
}: CreditSimulationBankAccountProps) => {
  const {
    values,
    errors,
    setFieldValue,
    submitForm,
    isValid,
    touched,
  }: FormikProps<CreditSimulationBankAccountFormValues> = useFormikContext();
  return (
    <SceneWrapper
      footer={
        <ButtonComponent
          id="btn-simulation-bank-account"
          onPress={submitForm}
          disabled={!isValid}
          fullWidth
        >
          AVANÇAR
        </ButtonComponent>
      }
    >
      <Select
        label="Qual o banco?"
        placeholder="Selecione um banco"
        id="bank"
        name="bank"
        error={touched?.bank && errors?.bank}
        onChange={({ name, value }) => setFieldValue(name, value)}
        value={values.bank}
        options={banks}
      />
      <Input
        name="agency"
        id="agency"
        placeholder="Agência"
        value={values.agency}
        onChange={(e) => setFieldValue('agency', e.target.value)}
        label="Qual a agência?"
        errors={errors?.agency}
      />
      <Input
        name="agencyDigit"
        id="agencyDigit"
        placeholder="Dígito da agência"
        value={values.agencyDigit}
        onChange={(e) => setFieldValue('agencyDigit', e.target.value)}
        label="Qual o dígito da agência?"
        errors={errors?.agencyDigit}
      />
      <Input
        name="account"
        id="account"
        placeholder="Conta"
        value={values.account}
        onChange={(e) => setFieldValue('account', e.target.value)}
        label="Qual a conta?"
        errors={errors?.account}
      />
      <Input
        name="accountDigit"
        id="accountDigit"
        placeholder="Dígito da conta"
        value={values.accountDigit}
        onChange={(e) => setFieldValue('accountDigit', e.target.value)}
        label="Qual o dígito da conta?"
        errors={errors?.accountDigit}
      />
    </SceneWrapper>
  );
};

export default CreditSimulationBankAccount;
